module.exports = __webpack_public_path__ + "static/media/undraw_profile.e45b38ba.png";